{{ user.userType | userType }}
<div>
  <small> {{ accessList }} </small>
</div>
